import React from 'react';

const MyContext = React.createContext({ isLatestVersion: false });

export default MyContext;
